import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import LeadRankingTableSet from "./LeadRanking.TableSet";
import LeadAnalisiKPISet from "../leadAnalisi/LeadAnalisi.KPISet";
import JSONPretty from 'react-json-pretty'

const LeadRanking = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showLeadRanking = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Leads')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <LeadAnalisiKPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showLeadRanking &&
                <LeadRankingTableSet dataProviderName={dataProviderName} filters={filters} />
            }
        </Box>
    )
}

export default LeadRanking;
